import { render } from "./FormPlanComponent.vue?vue&type=template&id=2f8ddc5b"
import script from "./FormPlanComponent.vue?vue&type=script&lang=js"
export * from "./FormPlanComponent.vue?vue&type=script&lang=js"

import "./FormPlanComponent.vue?vue&type=style&index=0&id=2f8ddc5b&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__